import { Link } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";

interface PageHeaderProps {
  backLink: string;
  pageTitle: string;
  backLinkState?: Record<string, unknown>;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  backLink,
  pageTitle,
  backLinkState,
}) => {
  return (
    <div className="bg-indigo-600 h-[63px] flex items-center px-2">
      <Link to={backLink} state={backLinkState}>
        <ChevronLeftIcon
          className="h-5 w-auto text-white pr-3"
          aria-hidden="true"
        />
      </Link>
      <h2 className="font-bold leading-7 text-white text-xl tracking-tight">
        {pageTitle}
      </h2>
    </div>
  );
};

export default PageHeader;
